import React, { createContext, useState, useContext } from "react";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import Callout from "./Callout";
import { accordionConfigData } from "../constants";
import ToggleHeader from "./ToggleHeader";
import ExcelUploader from "./ExcelUploader";
import FileDropRespondContainer from "./FileDropRespondContainer";
import { LoaderContainer } from "./LoaderContainer";
import { AppMainContext } from "../App";
import { ScriptsContext } from "../App";
import { Sentinel } from "../Validation/SentinelClass";

// Create a context for accordionData
export const AccordionContext = createContext();

const styleSheet = {
  AccordionItem: {
    marginBottom: "0px",
  },
};

const sentinel = new Sentinel(accordionConfigData);

function AccordionContainer() {
  const { appContext } = useContext(AppMainContext);
  const { scriptsContext } = useContext(ScriptsContext);
  const [accordionData, setAccordionData] = useState(accordionConfigData);
  sentinel.update(accordionData);

  const queues = {
    scriptsQueue: sentinel.scriptsQueue,
    filesQueue: sentinel.filesQueue,
  };

  return (
    <AccordionContext.Provider value={{ accordionData, setAccordionData }}>
      <Callout />
      <Accordion defaultActiveKey="0">
        {accordionConfigData.map((item) => {
          return (
            <>
              <Card
                style={{
                  ...styleSheet.AccordionItem,
                  marginBottom:
                    scriptsContext.launchedFromAccordionId === item.id
                      ? undefined
                      : "15px",
                }}
                key={`${item.id}-card`}
              >
                <Card.Header
                  style={styleSheet.cardHeader}
                  key={`card-header=${item.id}`}
                >
                  <ToggleHeader
                    key={`toggle-header${item.id}`}
                    eventKey={item.id}
                    isToggable={sentinel.checkToggable(item)}
                  >
                    {item.title}
                  </ToggleHeader>
                </Card.Header>
                <Accordion.Collapse
                  eventKey={item.id}
                  key={`accordion-collapse${item.id}`}
                >
                  {accordionData[item.id - 1].status === "Pending" ? (
                    <ExcelUploader
                      id={item.id}
                      dataModelId={appContext.dataModelId}
                    />
                  ) : (
                    <FileDropRespondContainer
                      file={accordionData[item.id - 1].file}
                      status={accordionData[item.id - 1].status}
                      id={item.id}
                      queues={queues}
                    />
                  )}
                </Accordion.Collapse>
              </Card>
              {scriptsContext.launchedFromAccordionId === item.id && (
                <LoaderContainer />
              )}
            </>
          );
        })}
      </Accordion>
    </AccordionContext.Provider>
  );
}

export default AccordionContainer;
